import { useEffect, useRef } from 'react';
export var supportsPassive = false;

try {
  var opts = {};
  Object.defineProperty(opts, 'passive', {
    // eslint-disable-next-line getter-return
    get: function get() {
      supportsPassive = true;
    }
  });
  window.addEventListener('test-passive', null, opts);
} catch (e) {}

export default function useScroll(target, onScroll, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$passive = _options.passive,
      passive = _options$passive === void 0 ? false : _options$passive,
      _options$capture = _options.capture,
      capture = _options$capture === void 0 ? false : _options$capture;
  var element = target || window;
  var scrollHandler = useRef(onScroll);
  scrollHandler.current = onScroll;
  useEffect(function () {
    var handler = function handler(e) {
      var _a;

      (_a = scrollHandler.current) === null || _a === void 0 ? void 0 : _a.call(scrollHandler, e);
    };

    element.addEventListener('scroll', handler, supportsPassive ? {
      capture: capture,
      passive: passive
    } : capture);
    return function () {
      return element.removeEventListener('scroll', handler, capture);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element]);
}